module.exports = __webpack_public_path__ + "img/level1_dead.b7368716.png";